
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import ClientManagementContent from "@/components/expertise/ClientManagementContent";

const ClientManagement = () => {
  useEffect(() => {
    document.title = "AI Client Relationship Management | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI client relationship management for law firms. Smart engagement, communication tools & automated workflows. Enhance client service.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'AI client relationship management for law firms. Smart engagement, communication tools & automated workflows. Enhance client service.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="pt-24 bg-background min-h-screen">
        <ClientManagementContent />
      </div>
      <FooterSection />
    </>
  );
};

export default ClientManagement;
